<template>
  <div class="container-document mt-3">
    <!--<pdf :src="src" v-if="fileExtension == 'pdf'" ></pdf>-->
    <RomaPDF :pdfDoc="src" v-if="fileExtension == 'pdf'" />
    <iframe
      v-else-if="
        fileExtension != 'pdf' &&
        fileExtension != 'jpg' &&
        fileExtension != 'png' &&
        fileExtension != 'jpeg'
      "
      class="responsive-iframe"
      :src="`https://docs.google.com/gview?url=${link}&embedded=true`"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    >
    </iframe>

    <div class="img-container" v-else>
      <img :src="link" />
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import { mapActions } from "vuex";
import RomaPDF from "../commons/RomaPDF.vue";
import RomaPdfBtnZoom from "../commons/RomaPdfBtnZoom.vue";
export default {
  name: "RomaFile",
  components: {
    //pdf,
    RomaPDF,
    //RomaPdfBtnZoom
  },
  props: {
    resource: {
      type: Object,
      required: true,
    },
  },
  computed: {
     src() {
          return `${process.env.VUE_APP_ROMA_PLANNER_API_URL}file/dowload/${this.resource.resourcesId}`;
     },

    link() {
      return `${process.env.VUE_APP_ROMA_PLANNER_API_URL}file/dowload/${this.resource.resourcesId}`;
    },

    fileExtension: function () {
      const nameArray = this.resource.fileName.split(".");
      const extension = nameArray[nameArray.length - 1];

      return extension;
    },
  },
  // mounted() {
  //     this.actionClickOnResource({ resourceId: this.resource.resourcesId, activityId: this.resource.activity.activityLessonId});
  // },
  methods: {
    ...mapActions({
      actionGetPdf: "actionGetPdf",
      // actionClickOnResource: "actionClickOnResource"
    }),
  },
};
</script>

<style Lang="scss" scoped>
.container-document {
  position: relative;
  overflow: hidden;
  width: 100%;
  margin: auto;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.19);
  background: url(../../assets/images/preloaders/preloader.gif) center center
    no-repeat;
}

.responsive-iframe {
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 80vh;
}

.img-container {
  position: relative;
  width: 100%;
  min-height: 80vh;
}

.btn-download {
  z-index: 10;
  position: fixed;
  margin: 5px;
  /* top: 5rem; */
}
</style>
